module.exports = __webpack_public_path__ + "img/logo-company-6.18fdef5e.png";